<div class="content-box">
  <app-breadcrumb pagina="SIC / e-SIC"></app-breadcrumb>

  <section class="sic" aria-labelledby="sic-titulo">
    <div class="sic-topo">
      <h1 class="sic-titulo" id="sic-titulo">Serviço de Informação ao Cidadão (SIC)</h1>
      <span class="sic-traco" aria-hidden="true"></span>
    </div>

    <ul class="sic-grade">
      @for (canal of canais; track canal.id) {
        <li>
          <a class="sic-card" [attr.data-cor]="canal.cor" [routerLink]="canal.link">
            <span class="sic-card-esfera" aria-hidden="true">
              <i-lucide [name]="canal.icone" size="34"></i-lucide>
            </span>

            <span class="sic-card-titulo">{{ canal.titulo }}</span>
          </a>
        </li>
      }
    </ul>

    @if (canal()) {
      <section class="sic-info" aria-labelledby="sic-info-titulo">
        <img
          class="sic-info-ilustracao"
          ngSrc="assets/images/ouvidoria/ouvidoria-ilustracao.png"
          width="300"
          height="237"
          priority
          alt=""
        />

        <div class="sic-info-corpo">
          <div class="sic-info-cabecalho">
            <span class="sic-info-selo" aria-hidden="true">
              <i-lucide name="info" size="18"></i-lucide>
            </span>

            <h2 class="sic-info-titulo" id="sic-info-titulo">Informações do SIC</h2>
          </div>

          <span class="sic-traco sic-traco-info" aria-hidden="true"></span>

          <p class="sic-info-responsavel">
            <i-lucide name="user-round" size="14" aria-hidden="true"></i-lucide>
            <span>Responsável</span>
            <span class="sic-info-responsavel-nome">{{ responsavel() }}</span>
          </p>

          <dl class="sic-info-grade">
            @for (info of informacoes(); track info.id) {
              <div class="sic-info-item">
                <dt class="sic-info-rotulo">
                  <i-lucide [name]="info.icone" size="14" aria-hidden="true"></i-lucide>
                  <span>{{ info.rotulo }}</span>
                </dt>

                <dd class="sic-info-valor">
                  @for (valor of info.valores; track valor.texto) {
                    <span class="sic-info-linha">
                      @if (href(valor); as endereco) {
                        <a class="sic-info-link" [href]="endereco">{{ valor.texto }}</a>
                      } @else {
                        {{ valor.texto }}
                      }
                    </span>
                  }
                </dd>
              </div>
            }
          </dl>

          <section class="sic-prazos" aria-labelledby="sic-prazos-titulo">
            <h3 class="sic-prazos-titulo" id="sic-prazos-titulo">Prazos de atendimento</h3>

            <dl class="sic-prazos-grade">
              @for (prazo of prazos(); track prazo.id) {
                <div class="sic-prazo">
                  <dt class="sic-prazo-rotulo">
                    <i-lucide [name]="prazo.icone" size="14" aria-hidden="true"></i-lucide>
                    <span>{{ prazo.rotulo }}</span>
                  </dt>

                  <dd class="sic-prazo-valor">{{ prazo.valor }}</dd>
                </div>
              }
            </dl>
          </section>

          <p class="sic-info-nota">
            <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
            Atendimento sujeito a alteração em feriados municipais.
          </p>
        </div>
      </section>
    } @else if (!carregando()) {
      <p class="sic-vazio" role="status">
        <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
        {{ naoPublicado }}
      </p>
    }
  </section>
</div>
